
import FooterMenu from './index.vue'
// 为组件提供 install 方法
FooterMenu.install = function (Vue) {
    Vue.component(FooterMenu.name, FooterMenu)
}
// 导出组件
export default FooterMenu
